const defaultHeaderTitle = "CME-Assist";

export { defaultHeaderTitle }